export default function getManagerStats(ctx) {
	return {
		prefix: "manager",
		widgets: [
			// {
			// 	code: 'clientsCount',
			// name:'',
			// 	url: '/stats/get-clients-count'
			// },
			// {
			// 	code: 'authorsCount',
			// name:'',
			// 	url: '/stats/get-authors-count'
			// },
			// {
			// 	code: 'managersCount',
			// name:'',
			// 	url: '/stats/get-managers-count'
			// },
			{
				code: "income",
				name: ctx.$t("stats.privateIncome"),
				url: "/stats/get-income",
				color: "success",
				icon: "CreditCardIcon",
				symbol: " €",
				type: "widget"
			},
			{
				code: "successRate",
				name: ctx.$t("stats.successOrder"),
				url: "/stats/get-success-rate",
				icon: "ThumbsUpIcon",
				delimited: true,
				color: "primary",
				type: "widget"
			},
			// {
			// 	code: 'incomeProfit',
			// name:'',
			// 	url: '/stats/get-income-profit'
			// },
			// {
			// 	code: 'ordersCount',
			// name:'',
			// 	url: '/stats/get-orders-count'
			// },
			{
				code: "totalOrdersCount",
				name: ctx.$t("stats.ordersCount"),
				url: "/stats/get-orders-count",
				icon: "FileTextIcon",
				color: "info",
				type: "widget"
			},
			{
				code: "paidOrdersCount",
				name: ctx.$t("stats.paidOrdersCount"),
				url: "/stats/get-orders-paid-count",
				icon: "FileTextIcon",
				color: "success",
				type: "widget"
			},
			{
				code: "waitingOrdersCount",
				name: ctx.$t("stats.waitingOrdersCount"),
				url: "/stats/get-orders-waiting-percent",
				color: "warning",
				symbol: " %",
				icon: "AlertCircleIcon",
				type: "widget"
			},

			{
				code: "graphIncome",
				name: ctx.$t("stats.graphIncome"),
				url: "/stats/get-graph-income",
				type: "chart",
				lineName: ctx.$t("stats.privateIncome")
			},
			{
				code: "graphOrders",
				name: ctx.$t("stats.graphOrders"),
				url: "/stats/get-graph-orders",
				type: "chart",
				multiple_series: true
			},
			{
				code: "graphOrdersPaid",
				name: ctx.$t("stats.graphOrdersPaid"),
				url: "/stats/get-graph-orders-waiting",
				type: "chart",
				lineName: ctx.$t("stats.waitingOrdersCount") + ", %"
			}
		]
	};
}
